<template>
  <div class="g-wp w1200">
    <div class="pdf">
      <div class="head">
        <h3> {{ datumName }}</h3>
        <span>{{ collectCount }}人收藏</span>
        <span>{{ browseCount }}人阅读</span>
      </div>
      <div v-if="isPdf" style="width: 800px; margin: 0 auto; padding: 20px 10px; border: 1px solid #ccc;">
        <GeminiScrollbar class="my-scroll-bar" @ready="ready">
          <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" style="display: block; width: 100%" @loaded="loaded" />
        </GeminiScrollbar>
      </div>
      <p v-else class="f-tac">暂不支持预览</p>
      <div class="button">
        <!-- 2019/08/07 暂时可以去掉该功能 -->
        <!-- <button @click="handleClickCollect" class="btn1">{{ collectBtnText }}</button> -->
        <button @click="handleClickPreview" class="btn2">下载</button>
        <!-- <button class="btn3 btnRigth" @click.stop="topage('+')">下一页</button>
        <button class="btn4 btnRigth" @click="topage('-')">上一页</button> -->
      </div>
    </div>

    <!-- 相关文档列表 -->
    <div class="correlationPdf">
      <h3 v-if="pdfList.length > 0">相关文档</h3>
      <ul v-if="pdfList.length > 0" class="pdf-list">
        <li v-for="( item, index ) in pdfList" :key="index" @click="toPdfDetail( item )">
          <img :src="item | getFileTypeIcon" alt="">
          <div class="p">
            <a href="javascript:;">{{ item.datumName }}</a>
            <span class="s2">{{ item.studyCount }}人阅读</span>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
/* global YitongToken */
/* global gotoLogin */
/* global $http */

import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  name: 'pdfDetail',
  data() {
    return {
      // 文件名
      datumName: '',
      // 阅读人数
      browseCount: 0,
      // 收藏人数
      collectCount: 0,
      //
      collectBtnText: '收藏',
      //
      pdfList: [],
      // pdf文件页码
      currentPage: 1,
      // pdf文件总页数
      pageCount: 20,
      // 文件类型
      isPdf: null,
      // pdf文件地址
      src: '',
      // pdf插件src
      pdfSrc: null,
      //
      numPages: undefined
    }
  },
  mounted() {},
  created() {
    this.datumId = this.$route.query.datumId

    if (!YitongToken.get()) {
      gotoLogin()
      return
    }

    this.getFileData().then(() => {
      this.getPdefList()
    })
  },
  methods: {
    /**
     * 预览文件
     */
    handleClickPreview() {
      if (!YitongToken.get()) {
        gotoLogin()
        return
      }
      window.open(this.src)
    },

    /**
     * 收藏
     */
    handleClickCollect() {
      if (!YitongToken.get()) {
        gotoLogin()
        return
      }

      if (this.collectStat) {
        // 取消收藏
        $http
          .post('/yswx/gw/course/deleteCourseDatumCollect', {
            datumId: this.datumId
          })
          .then(() => {
            this.collectBtnText = '收藏'
            this.collectStat = false
            this.collectCount--
          })
      } else {
        // 收藏
        $http
          .post('/yswx/gw/course/addCourseDatumCollect', {
            datumId: this.datumId
          })
          .then(() => {
            this.collectBtnText = '取消收藏'
            this.collectStat = true
            this.collectCount++
          })
      }
    },

    /**
     * 获取文件详情数据
     */
    getFileData() {
      return $http
        .post('/yswx/gw/videoCourse/getDatumDetailForPC', {
          datumId: this.datumId
        })
        .then(data => {
          this.collectBtnText = data.result.collectStat ? '取消收藏' : '收藏'
          this.collectStat = data.result.collectStat
          this.datumName = data.result.datumName
          this.browseCount = data.result.browseCount
          this.collectCount = data.result.collectCount
          this.src = data.result.uri

          this.pdfSrc = pdf.createLoadingTask(data.result.uri)
          this.pdfSrc.then(pdf => {
            this.numPages = pdf.numPages
            // this._geminiScrollbar.update()
          })

          this.isPdf = /.+(\.pdf)/.test(this.src)

          return data
        })
        .catch(err => Promise.reject(err))
    },

    /**
     * 跳转文档详情
     */
    toPdfDetail(row) {
      const routeUrl = this.$router.resolve({
        path: '/pdfDetail',
        query: {
          datumId: row.datumId
        }
      })
      window.open(routeUrl.href, '_blank')
    },

    /**
     *
     */
    topage(type) {
      type === '+' ? this.currentPage++ : this.currentPage--
      if (this.currentPage < 1) {
        this.currentPage = 1
      }
      if (this.currentPage > this.pageCount) {
        this.currentPage = this.pageCount
      }
    },

    /**
     * 获取相关文档数据
     */
    getPdefList() {
      $http
        .post('/yswx/gw/videoCourse/getSimilarDatum', {
          // [搜索关键词]
          searchText: this.datumName,
          // [园所ID]
          // schoolId: '2980',
          // [分页数量]
          pageSize: 6,
          // [加载更多标识]
          next: ''
        })
        .then(data => {
          this.pdfList = data.result.list || []
        })
    },

    /**
     *
     */
    toDetail() {
      this.currentPage++
    },

    ready(geminiScrollbar) {
      this._geminiScrollbar = geminiScrollbar
    },

    loaded() {
      setTimeout(() => {
        this._geminiScrollbar.update()
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
.pdf {
  .head {
    height: 67px;
    h3 {
      padding: 20px 0;
      color: #3d3d3d;
      display: inline-block;
      font-size: 24px;
    }
    span {
      float: right;
      padding: 0 15px;
      border-right: 1px solid #e4e4e4;
      vertical-align: middle;
      margin-top: 20px;
    }
  }
  .button {
    padding: 20px 0;
    button {
      width: 127px;
      height: 31px;
      border: 0;
      border-radius: 2px;
      margin: 0 10px;
    }
    .btn1 {
      background-color: #d81617;
      color: #fff;
      margin-left: 0;
    }
    .btn4 {
      margin-right: 0;
    }
    .btnRigth {
      float: right;
      color: #fff;
      background-color: #409eff;
    }
  }
  .my-scroll-bar {
    width: 800px;
    height: 1120px;
  }
}
</style>